export const colors = {
	tooltipBackground: '#09514e',
};
